module.exports = __webpack_public_path__ + "static/media/no-applications.69b4f34c.png";